var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationBellSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.181 19.115C10.3937 18.9388 10.7089 18.9684 10.8851 19.181C11.1067 19.4485 11.3646 19.6546 11.6412 19.7929C11.9173 19.931 12.2088 20 12.5 20C12.7912 20 13.0827 19.931 13.3588 19.7929C13.6354 19.6546 13.8934 19.4485 14.115 19.181C14.2911 18.9684 14.6063 18.9388 14.819 19.115C15.0316 19.2911 15.0612 19.6063 14.8851 19.819C14.5814 20.1856 14.2158 20.4825 13.806 20.6873C13.3958 20.8924 12.9517 21 12.5 21C12.0484 21 11.6042 20.8924 11.194 20.6873C10.7843 20.4825 10.4187 20.1856 10.115 19.819C9.93881 19.6063 9.96839 19.2911 10.181 19.115Z",
    fill: "#545454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 2C12.7761 2 13 2.22386 13 2.5V3.5C13 3.77614 12.7761 4 12.5 4C12.2239 4 12 3.77614 12 3.5V2.5C12 2.22386 12.2239 2 12.5 2Z",
    fill: "#545454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9.5C6 5.91015 8.91015 3 12.5 3C16.0899 3 19 5.91015 19 9.5V13.382C19 13.8778 19.2801 14.331 19.7236 14.5528L20.0403 14.7111C20.6285 15.0052 21 15.6064 21 16.2639C21 17.2227 20.2227 18 19.2639 18H5.73607C4.77726 18 4 17.2227 4 16.2639C4 15.6064 4.37152 15.0052 4.95967 14.7111L5.27639 14.5528C5.71987 14.331 6 13.8778 6 13.382V9.5ZM12.5 4C9.46243 4 7 6.46243 7 9.5V13.382C7 14.2566 6.50587 15.0561 5.72361 15.4472L5.40689 15.6056C5.15752 15.7303 5 15.9851 5 16.2639C5 16.6705 5.32955 17 5.73607 17H19.2639C19.6705 17 20 16.6705 20 16.2639C20 15.9851 19.8425 15.7303 19.5931 15.6056L19.2764 15.4472C18.4941 15.0561 18 14.2566 18 13.382V9.5C18 6.46243 15.5376 4 12.5 4Z",
    fill: "#FF801F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationBellSmall);
export default __webpack_public_path__ + "static/media/notification-bell-small.67a6677f229befa12a2c6ddf64643ebf.svg";
export { ForwardRef as ReactComponent };